import React from 'react';
import clsx from "clsx";
import './Container.scss'
const Container = ({ style, className,children }:{style?:object,className?:string,children:React.ReactNode}) => {
    return (
        <div style={style??{}} className={clsx('container-c',className)}>
            {children}
        </div>
    );
};

export default Container;
